import { Project } from "pmt-types/src/models/Project.ts";
import { useMutation } from "react-query";
import { useAuthentication } from "../useAuthentication.ts";

export const useMutationUpsertProject = () => {
  const { accessToken } = useAuthentication();

  return useMutation(
    async (project: Project) => {
      const response = await fetch(
        `${import.meta.env.VITE_API_HOST}/projects`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
          body: JSON.stringify(project),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to upsert project");
      }

      return (await response.json()) as Project;
    },
    {
      onError: (error, data) => {
        console.error("Failed to upsert project", error, data);
      },
    },
  );
};
